import React, { Component } from 'react';
import { connect } from "react-redux";
import intl from 'react-intl-universal';
import Box from '@mui/material/Box';
import LogListResults from './LogListResults';

class LogsDash extends Component {

    render () { 
        return (
          <Box  sx={{ p: 2, border: '1px dashed grey' }}>
              <h1>{intl.get('SYSTEMLOG')}</h1>
              <p>{intl.get('DASH_SYSTEMLOG_DESC')}</p> 
              <hr />
              <LogListResults apitoken={this.props.apitoken}/>
          </Box>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken
  });

export default connect(mapStateToProps)(LogsDash);